import { LabAnalysisDto } from "@/Common/Api/Patient/LabAnalysisDto";

class LabAnalysisModel implements LabAnalysisDto {
    public StandardObservationCode: string;
    public ObservationCode: string;
    public Description: string;
    public DescriptionShort: string;
    public Unit: string;

    constructor(dto: LabAnalysisDto) {
        Object.assign(this, dto);
    }

    public getLabel(): string {
        return `${this.DescriptionShort} - ${this.ObservationCode}`;
    }

    public getId(): string {
        return this.StandardObservationCode;
    }
}

export { LabAnalysisModel };
